import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessageWrappedInSpan } from '../../misc';

import {
  ORIGINAL,
  SINGLE_PHOTO,
  FOTO_FLAT,
  VIDEO,
  CERTIFICATE,
  SOCIAL_MEDIA,
  VOUCHER,
  ALL_PHOTOS
} from '../../../utils/variables';

import PhotoIcon from '@material-ui/icons/Photo';
import PhotoLibraryRoundedIcon from '@material-ui/icons/PhotoLibraryRounded';
import TheatersRoundedIcon from '@material-ui/icons/TheatersRounded';
import CardGiftcardRoundedIcon from '@material-ui/icons/CardGiftcardRounded';
import CardMembershipRoundedIcon from '@material-ui/icons/CardMembershipRounded';

import AccountDownloadTileZipDownload from './AccountDownloadTileZipDownload';
import AccountDownloadTileVideo from './AccountDownloadTileVideo';
import AccountDownloadTileVoucher from './AccountDownloadTileVoucher';
import AccountDownloadDialogTile from './AccountDownloadDialogTile';
import PermMediaRoundedIcon from '@material-ui/icons/PermMediaRounded';

const AccountDownloadTile = ({
  type,
  notActive,
  restartState,
  onScrollToMedia,
  values,
  eventSgId,
  isFaceSearchEvent,
  intl
}) => {
  switch (type) {
    case SINGLE_PHOTO:
      return (
        <AccountDownloadDialogTile
          icon={<PhotoIcon className="account-tile-icon" />}
          textInSpan={
            <FormattedMessageWrappedInSpan
              id="messages.singlePhoto"
              defaultMessage="Single Photo"
            />
          }
          type={type}
          onScrollToMedia={onScrollToMedia}
        />
      );
    case FOTO_FLAT:
      return (
        <AccountDownloadTileZipDownload
          icon={<PhotoLibraryRoundedIcon className="account-tile-icon" />}
          textInSpan={
            <FormattedMessageWrappedInSpan
              id="messages.fotoFlat"
              defaultMessage="Foto-Flat"
            />
          }
          type={type}
          eventSgId={eventSgId}
          values={values?.filter(
            (element) => element != ORIGINAL && element != SOCIAL_MEDIA
          )}
          isFaceSearchEvent={isFaceSearchEvent}
        />
      );
    case VIDEO:
      return (
        <AccountDownloadTileVideo
          icon={<TheatersRoundedIcon className="account-tile-icon" />}
          textInSpan={
            <FormattedMessageWrappedInSpan
              id="accountEventPage.products.video"
              defaultMessage="Video"
            />
          }
          notActive={notActive}
          type={type}
          values={values}
          eventSgId={eventSgId}
          isFaceSearchEvent={isFaceSearchEvent}
          intl={intl}
        />
      );
    case CERTIFICATE:
      return (
        <AccountDownloadDialogTile
          icon={<CardMembershipRoundedIcon className="account-tile-icon" />}
          textInSpan={
            <FormattedMessageWrappedInSpan
              id="accountEventPage.products.certificate"
              defaultMessage="Certificate"
            />
          }
          type={type}
          onScrollToMedia={onScrollToMedia}
          notActive={notActive}
        />
      );
    case ALL_PHOTOS:
      return (
        <AccountDownloadTileZipDownload
          icon={<PermMediaRoundedIcon className="account-tile-icon" />}
          textInSpan={
            <FormattedMessageWrappedInSpan
              id="accountEventPage.products.allPhotos"
              defaultMessage="All photos"
            />
          }
          restartState={restartState}
          eventSgId={eventSgId}
          type={type}
          values={values?.filter(
            (element) => element === ORIGINAL || element === SOCIAL_MEDIA
          )}
        />
      );
    case VOUCHER:
      return (
        <AccountDownloadTileVoucher
          icon={<CardGiftcardRoundedIcon className="account-tile-icon" />}
          textInSpan={
            <FormattedMessageWrappedInSpan
              id="accountEventPage.products.voucher"
              defaultMessage="Voucher"
            />
          }
          values={values}
        />
      );
  }
};

AccountDownloadTile.propTypes = {
  type: PropTypes.string,
  values: PropTypes.array,
  notActive: PropTypes.bool,
  restartState: PropTypes.string,
  onScrollToMedia: PropTypes.func,
  eventSgId: PropTypes.number,
  isFaceSearchEvent: PropTypes.bool,
  intl: PropTypes.object,
};

export default AccountDownloadTile;
